import { render, staticRenderFns } from "./UpdateGratisTicketModal.vue?vue&type=template&id=58043c41&scoped=true"
import script from "./UpdateGratisTicketModal.vue?vue&type=script&lang=js"
export * from "./UpdateGratisTicketModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateGratisTicketModal.vue?vue&type=style&index=0&id=58043c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58043c41",
  null
  
)

export default component.exports